export const OTHER_OPTION_CODE = "O";
export const EMPLOYMENT_OTHER_OPTION_CODE = "Other";
export const OTHER_OPTION_VALUE = "Other";

export const MAX_EMPLOYMENT_TYPE_OTHER_LENGTH = 50;
export const MAX_DESIGNATION_LENGTH = 50;
